<template>
  <div class="one-column-width">
    <!-- show action result -->
    <v-snackbar v-model="snackbar" absolute top right color="success">
      <span>{{ snackBarText }}</span>
      <v-icon dark>mdi-checkbox-marked-circle</v-icon>
    </v-snackbar>

    <v-snackbar v-model="errorMessage" absolute top right color="danger">
      <span>Something went RONG, Please Try Again!</span>
      <v-icon dark>mdi-checkbox-marked-circle</v-icon>
    </v-snackbar>

    <!-- Confirm Delete Item -->

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="380px">
        <v-card>
          <v-card-title>
            <span class="headline">Do you really want to DELETE this item?</span>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="custom-submit-button" text @click="dialog = false">No</v-btn>
            <v-btn class="custom-cancel-button" text @click="deleteItem"
              ><b-spinner small type="grow" v-if="deleting"></b-spinner>Delete</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>


    <div class="row">
      <div class="col-12">
        <!-- table start -->
        <v-card class="r_tabsform_card">
          <v-card-title class="r_form_card_title">
            Programs
            <!-- <div class="my-2 ml-2">
              <v-btn
                class="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1"
                fab
                small
                @click="showForm"
              >
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
            </div> -->
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              class="r_form_top_search"
              append-icon="search"
              label="Search Programs"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <hr class="r_form_card_top_hr">

          <v-data-table class="r_admn_dashboad_tdss" :headers="headers" :items="tableData" :search="search" loading>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                class="btn btn-sm btn-light font-weight-bold py-3 px-3 px-xxl-5 my-1 "
                fab
                small
                @click="showEditForm(item)"
              >
                <v-icon class="text-success">fas fa-edit fa-lg</v-icon>
              </v-btn>
              &nbsp;
              <v-btn
                class="btn btn-sm btn-light font-weight-bold py-3 px-3 px-xxl-5 my-1"
                fab
                small
                @click="askUserAboutDelete(item)"
              >
                <v-icon class="text-danger">mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <div class="r_form_add_more_btnnn_div">
            <button @click="showForm" class="r_form_add_more_btnnn">Add new program</button>
          </div>
        </v-card>

        <!-- table end -->
      </div>


      <div class="col-12">
        <!-- form start -->
        <v-card class="r_tabsform_card" v-if="showFormData">
          <v-card-title class="r_form_card_title ext_pdg_to_lvl"> Add New Program </v-card-title>
          <hr class="r_form_card_top_hr">

          <div>
            <v-form ref="form" @submit.prevent="submit" class="">
              <v-container fluid>
                <v-col cols="12" sm="12">
                  <v-row v-for="(item, index) in form" :key="index">
                    <div class="col-md-4 py-0 inputs_mange text-center">
                      <v-text-field
                      v-model="item.name"
                      :rules="rules.name"
                      color="purple name-2"
                      class="r_formtabs_inputs col-6"
                      label="Program Name"
                      required
                    ></v-text-field>
                    </div>
                    <div class="col-md-4 py-0 inputs_mange text-center">
                      <v-autocomplete
                      v-model="item.department_id"
                      :rules="rules.department_id"
                      :items="departments"
                      class="r_formtabs_inputs col-6"
                      label="Program Department"
                    ></v-autocomplete>
                    </div>
                    <div class="col-md-4 py-0 inputs_mange text-center">
                      <v-autocomplete
                      v-model="item.level_id"
                      :rules="rules.level_id"
                      :items="levels"
                      class="r_formtabs_inputs col-6"
                      label="Program Level"
                    ></v-autocomplete>
                    </div>
                    <div class="col-md-4 py-0 inputs_mange text-center">
                      <v-autocomplete
                      v-model="item.duration"
                      :rules="rules.duration"
                      :items="durations"
                      class="r_formtabs_inputs col-6"
                      label="Program duration"
                    ></v-autocomplete>
                    </div>
                    <div class="col-md-4 py-0 inputs_mange text-center">
                      <v-text-field
                      v-model="item.credit_hours"
                      :rules="rules.credit_hours"
                      color="purple name-2"
                      class="r_formtabs_inputs col-6"
                      label="Program Credit Hours"
                    ></v-text-field>
                    </div>
                    <!-- <template v-if="!editId">
                      <button
                        class="r_form_add_more_recods_btnnn col-2"
                        type="button"
                        @click="addNewRow()"
                        >Add</button
                      >
                      <button
                        v-if="index > 0"
                        class="r_cust_del_new_rec_btn col-2"
                        type="button"
                        @click="deleteRow(index)"
                        >Delete</button
                      >
                    </template> -->
                  </v-row>
                </v-col>
              </v-container>
              <v-card-actions class="pl-4 ml-4 pb-4">
                <button
                  :disabled="$v.$invalid || submitting"
                  class="r_form_add_more_btnnn"
                  type="submit"
                  ><b-spinner small type="grow" v-if="submitting"></b-spinner>
                  <span v-if="!editId">Submit</span>
                  <span v-if="editId">Update</span>
                </button>
                <button text @click="cancelForm" class="r_form_cancel_more_btnnn">Cancel</button>
              </v-card-actions>
            </v-form>
          </div>
        </v-card>
        <!-- form end -->
      </div>
    </div>

    

    
  </div>
</template>

<script>
import DepartmentService from "@/MainServices/DepartmentService.js";
import ProgramService from "@/MainServices/ProgramService.js";
import LevelService from "@/MainServices/LevelService.js";
import LocationService from "@/MainServices/LocationService.js";
import { required, minLength } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      form: [{ name: "", department_id: null, level_id: null, duration: null, credit_hours: null, }],
      departments: [],
      levels: [],
      durations: [],
      editId: null,
      deleteId: null,
      dialog: false,
      rules: {
        department_id: [(val) => !!val || "Department is required"],
        name: [(val) => (val || "").length > 0 || "Name is required"],
        level_id: [(val) => !!val || "level is required"],
        duration: [(val) => !!val || "Duration is required"],
        // credit_hours: [(val) => !!val || "Credit Hours is required"],
      },
      snackbar: false,
      snackBarText: null,
      submitting: false,
      deleting: false,
      errorMessage: false,
      search: "",
      showFormData: false,
      headers: [
        { text: "Campus", align: "left", sortable: false, value: "campus", width: "20%", class: "r_admn_dashboad_title" },
        {
          text: "Department",
          align: "left",
          sortable: false,
          value: "department",
          width: "18%",
          class: "r_admn_dashboad_title"
        },
        {
          text: "Level",
          align: "left",
          sortable: false,
          value: "level",
          width: "13%",
          class: "r_admn_dashboad_title"
        },
        {
          text: "Duration",
          align: "left",
          sortable: false,
          value: "duration",
          width: "10%",
          class: "r_admn_dashboad_title"
        },
        {
          text: "Program",
          align: "left",
          sortable: false,
          value: "program",
          width: "15%",
          class: "r_admn_dashboad_title"
        },
        {
          text: "Credit Hours",
          align: "left",
          sortable: false,
          value: "credit_hours",
          width: "10%",
          class: "r_admn_dashboad_title"
        },

        { text: "Actions", value: "actions", sortable: false, class: "r_admn_dashboad_title" },
      ],
      tableData: [],
    };
  },
  validations: {
    form: {
      required,
      $each: {
        name: { minLength: minLength(3), required },
        department_id: { required },
        level_id: { required },
        duration: { required },
        // credit_hours: { required },
      },
    },
  },
  components: {},

  computed: {},

  methods: {
    getInititalData() {
      ProgramService.getInstitutePrograms()
        .then((res) => {
          let data = [];
          res.data.map((el) => {
            el.departments.map((el2) => {
              el2.programs.map((el3) => {
                // console.log(el3);
                data.push({
                  campus: el.name,
                  department: el2.department,
                  department_id: el3.department_id,
                  program: el3.program,
                  duration: el3.duration,
                  credit_hours: el3.credit_hours,
                  level: el3.level.level,
                  level_id: el3.level_id,
                  id: el3.id,
                });
              });
            });
          });
          this.tableData = data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // main methods
    showForm() {
      this.editId = null;
      this.showFormData = true;
      this.resetForm();
    },
    showEditForm(item) {
      this.form = [
        {
          name: item.program,
          department_id: item.department_id,
          level_id: item.level_id,
          duration: item.duration,
          credit_hours: item.credit_hours,
        },
      ];
      this.editId = item.id;
      this.showFormData = true;
    },
    cancelForm() {
      this.resetForm();

      this.showFormData = false;
    },
    resetForm() {
      this.form = [{ name: "", department_id: null, level_id: null, duration: null, credit_hours: null }];
      this.editId = null;
      setTimeout(() => {
        if (this.$refs.form) {
          this.$refs.form.reset();
        }
      }, 100);
    },
    // addNewRow() {
    //   this.form.push({ city: "", country_id: null });
    // },
    // deleteRow(index) {
    //   this.form.splice(index, 1);
    // },
    submit() {
      this.submitting = true;
      if (this.editId) {
        ProgramService.editProgram(this.form, this.editId)
          .then((res) => {
            this.resetForm();
            this.getInititalData();
            this.submitting = false;
            this.snackBarText = "City Updated successful!";
            this.snackbar = true;
          })
          .catch((error) => {
            this.errorMessage = true;
          });
      } else {
        ProgramService.addNewPrograms(this.form)
          .then((res) => {
            this.resetForm();
            this.getInititalData();
            this.submitting = false;
            this.snackBarText = "Program Added successful!";
            this.snackbar = true;
          })
          .catch((error) => {
            this.errorMessage = true;
          });
      }
    },
    askUserAboutDelete(item) {
      this.deleteId = item.id;
      this.dialog = true;
    },
    deleteItem() {
      this.deleting = true;
      ProgramService.deleteProgram(this.deleteId)
        .then((res) => {
          this.editId = null;
          this.deleting = false;
          this.dialog = false;
          this.resetForm();
          this.getInititalData();
          this.snackBarText = "Program Deleted successful!";
          this.snackbar = true;
        })
        .catch((error) => {
          this.errorMessage = true;
          this.dialog = false;
        });
    },
  },
  mounted() {
    this.getInititalData();
    DepartmentService.getInstituteDepartments()
      .then((res) => {
        res.data.map((el) => {
          el.departments.map((el2) => {
            this.departments.push({
              value: el2.id,
              text: el2.department,
            });
          });
        });
      })
      .catch(() => {
        this.loading = false;
      });
    LevelService.getLevels()
      .then((res) => {
        res.data.map((el) => {
          this.levels.push({ value: el.id, text: el.level });
        });
      })
      .catch(() => {
        this.loading = false;
      });
    this.durations.push(
      { value: "1 Year", text: "1 Year" },
      { value: "1 Year 3 Month", text: "1 Year 3 Month" },
      { value: "1 Year 6 Month", text: "1 Year 6 Month" },
      { value: "2 Year", text: "2 Year" },
      { value: "2 Year 6 Month", text: "2 Year 6 Month" },
      { value: "3 Year", text: "3 Year" },
      { value: "3 Year 6 Month", text: "3 Year 6 Month" },
      { value: "4 Year", text: "4 Year" },
      { value: "4 Year 6 Month", text: "4 Year 6 Month" },
      { value: "5 Year", text: "5 Year" },
      { value: "1 Month", text: "1 Month" },
      { value: "2 Month", text: "2 Month" },
      { value: "3 Month", text: "3 Month" },
      { value: "4 Month", text: "4 Month" },
      { value: "5 Month", text: "5 Month" },
      { value: "6 Month", text: "6 Month" },
      { value: "7 Month", text: "7 Month" },
      { value: "8 Month", text: "8 Month" },
      { value: "9 Month", text: "9 Month" },
      { value: "10 Month", text: "10 Month" },
      { value: "11 Month", text: "11 Month" },
      { value: "12 Month", text: "12 Month" }
    );
  },
};
</script>


<style scoped>
.text-success {
    color: #2eca8b !important;
}
.text-danger {
    color: #a82511 !important;
}

</style>
